module.exports = __webpack_public_path__ + "static/media/ball_4_5.b85ed723.mp3";